// extracted by mini-css-extract-plugin
module.exports = {"artikkelDato":"ArtikkelDato_artikkelDato__dFxBD","small":"ArtikkelDato_small__GS21u","divider":"ArtikkelDato_divider__NF_37"};